import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { View, FlatList, useWindowDimensions } from 'react-native';
import { Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledDropdown from '../../../components/ControlledComponents/CustomControlledDropdown';
import { useTableHelper } from '../../../hooks/useTableHelper';


const FlatListView = React.memo(({ item, styles, t, convertDate, handleDelete,
    modal, control, setValue, ActivityIndicator, index,
    providentFundDropdown, contrEmplDropdown, contrEmployerDropdown, width
}) => {

    //#region Variables
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [startDateCalendar, setDoaCalendar] = useState([]);
    const [endDateCalendar, setDotCalendar] = useState([]);
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [pressed, setPressed] = useState();
    //#endregion

    //#region UseEffects
    useEffect(() => {
        const dateToSet = startDateCalendar?.startDate ? convertDate(startDateCalendar.startDate) : '';
        setValue(`${item?.ui}.startdate`, dateToSet);
    }, [startDateCalendar]);

    useEffect(() => {
        const dateToSet = endDateCalendar?.startDate ? convertDate(endDateCalendar.startDate) : '';
        setValue(`${item?.ui}.enddate`, dateToSet);
    }, [endDateCalendar]);

    useEffect(() => {
        let startdate = item?.startdate;
        if (startdate) {
            setDoaCalendar({ startDate: startdate });
        } else {
            setDoaCalendar({ startDate: '' });
        }

        let enddate = item?.enddate;
        if (enddate) {
            setDotCalendar({ startDate: enddate });
        } else {
            setDotCalendar({ startDate: '' });
        }
    }, []);
    //#endregion

    //#region Show / Hide
    const onShowCalendarPress = (btn) => {
        if (pressed === btn) {
            setPressed(null);
            setCalendarVisible(false);
            setShowCalendar(!showCalendar);
        }
        else {
            setPressed(btn);
            setCalendarVisible(true);
            setShowCalendar(true);
        }
    }

    const onShowAdditionalLocationInfoPress = (item) => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }
    //#endregion

    //#region Calendar
    const renderCalendar = () => {
        return (
            <SafeAreaView style={styles.secondLine}>
                {/* calendar view */}
                <View style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 10,
                    borderWidth: 0,
                    borderColor: colors.border_card,
                }}>
                    <CustomCalendar
                        calendarType={'RangePicker'}
                        setRange={pressed === 'startdate' ? setDoaCalendar : setDotCalendar}
                        range={pressed === 'startdate' ? startDateCalendar : endDateCalendar}
                        allowSingleDate={true}
                        startingYear={1990}
                    />
                </View>
            </SafeAreaView>
        )
    }
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <ActivityIndicator animating={true} />
        )
    //#endregion

    return (
        <SafeAreaView>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView style={styles.row}>
                        <View
                            style={[styles.item]}>
                            <SafeAreaView>
                                <CustomLabel value={t(`common:provFund`)} type='SUBTITLENOFLEX' />
                                <CustomControlledDropdown
                                    multipleSelect={true}
                                    control={control}
                                    name={`${item.ui}.provfundUI`}
                                    type="TIMESHEET"
                                    options={providentFundDropdown}
                                    rules={{
                                        required: t('common:provFundReqMess'),
                                    }}
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <CustomLabel value={t(`common:startDate`)} type='SUBTITLENOFLEX' />
                            <SafeAreaView style={styles.row}>
                                <CustomControlledInput
                                    name={`${item.ui}.startdate`}
                                    control={control}
                                    editable={false}
                                    type='EDIT_EMPLOYEE'
                                />
                                <Ionicons
                                    name={pressed === 'startdate' ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={() => onShowCalendarPress('startdate')}
                                />
                            </SafeAreaView>
                        </View>
                        <View
                            style={[styles.item]}>
                            <CustomLabel value={t(`common:endDate`)} type='SUBTITLENOFLEX' />
                            <SafeAreaView style={styles.row}>
                                <CustomControlledInput
                                    name={`${item.ui}.enddate`}
                                    control={control}
                                    editable={false}
                                    type='EDIT_EMPLOYEE'
                                />
                                <Ionicons
                                    name={pressed === 'enddate' ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={() => onShowCalendarPress('enddate')}
                                />
                            </SafeAreaView>
                        </View>
                        <View style={styles.verticalLine} />
                        <SafeAreaView style={[{ flexDirection: width < 1300 ? 'column' : 'row' }]}>
                            <CustomButton
                                iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                onPress={() => {
                                    onShowAdditionalLocationInfoPress()
                                }}
                                text={t('common:additionalInfos')}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                            <CustomButton
                                iconName={"trash-outline"}
                                onPress={() => {
                                    handleDelete(item, index, 'ui', modal)
                                }}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.justMargin}></SafeAreaView>
                    </SafeAreaView>
                    {showAdditionalInformation &&
                        <SafeAreaView>
                            <SafeAreaView style={styles.row}>
                                <View
                                    style={[styles.item]}>
                                    <SafeAreaView>
                                        <CustomLabel value={t(`common:emplContribution`)} type='SUBTITLENOFLEX' />
                                        <CustomControlledDropdown
                                            multipleSelect={true}
                                            control={control}
                                            name={`${item.ui}.emplPercentage`}
                                            type="TIMESHEET"
                                            options={contrEmplDropdown}
                                            rules={{
                                                required: t('common:emplContrReqMess'),
                                            }}
                                        />
                                    </SafeAreaView>
                                </View>
                                <View
                                    style={[styles.item]}>
                                    <SafeAreaView>
                                        <CustomLabel value={t(`common:employerContribution`)} type='SUBTITLENOFLEX' />
                                        <CustomControlledDropdown
                                            multipleSelect={true}
                                            control={control}
                                            name={`${item.ui}.provFundPercentage`}
                                            type="TIMESHEET"
                                            options={contrEmployerDropdown}
                                            rules={{
                                                required: t('common:employerContrReqMess'),
                                            }}
                                        />
                                    </SafeAreaView>
                                </View>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                    {showCalendar && calendarVisible &&
                        renderCalendar()
                    }
                </SafeAreaView>
            </SafeAreaView>
        </SafeAreaView>
    )
})


const HRAdminProvidentFund = ({ props }) => {
    const { selectedEmployee, convertDate, styles,
        modal, t, modalVisible, setModalVisible, ActivityIndicator, colors, renameKeysInOptions, selectedCompany
    } = props;
    const { width, height } = useWindowDimensions();
    const [changes, setChanges] = useState([]);
    const { getDropdownValues, getProvidentFund, insertProvidentFund, updateProvidentFund, deleteProvidentFund } = useHRAdminEmployees();
    const [providentFundDetails, setProvidentFundDetails] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [originalProvidentFundDetails, setOriginalProvidentFundDetails] = useState([]);
    const [duplicates, setDuplicates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { handleCancelChanges, rowAdd, rowDelete, } = useTableHelper();
    const { control, handleSubmit, formState: { errors }, setValue, unregister, register } = useForm();
    const [providentFundDropdown, setProvidentFundDropdown] = useState([]);
    const [contrEmplDropdown, setContrEmplDropdown] = useState([]);
    const [contrEmployerDropdown, setContrEmployerDropdown] = useState([]);
    const sParams = [
        { ApprProvFund: { sFilt1: selectedEmployee?.employeeID, sFilt2: "", sFilt3: "" } },
        { EmployeeContribution: { sFilt1: selectedEmployee?.employeeID, sFilt2: "", sFilt3: "" } },
        { EmployerContribution: { sFilt1: selectedEmployee?.employeeID, sFilt2: "", sFilt3: "" } }
    ];
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const ref = useRef(null);

    //#region UseEffect
    useEffect(() => {
        setIsLoading(true);
        getDropdownValues(sParams).then((res) => {
            let provFund = renameKeysInOptions(res?.ApprProvFund);
            let emplContr = renameKeysInOptions(res?.EmployeeContribution);
            let emplerContr = renameKeysInOptions(res?.EmployerContribution);

            setProvidentFundDropdown(provFund);
            setContrEmplDropdown(emplContr);
            setContrEmployerDropdown(emplerContr);

            getProvidentFund(selectedEmployee?.employeeID).then((res) => {
                let provFund = res?.data;
                setProvidentFundDetails(provFund);
                setOriginalProvidentFundDetails(provFund);
                provFund.forEach((item, index) => {
                    item['startdate'] = item?.startdate?.split('T')[0];
                    item['enddate'] = item?.enddate?.split('T')[0];
                    Object.keys(item).forEach(key => {
                        setValue(`${item.ui}.${key}`, item[key]);
                    });
                });
                setIsLoading(false);
            });
        })
    }, []);

    useEffect(() => {
        if (providentFundDetails.length <= 0) return;
        let item = providentFundDetails[0];
        Object.keys(item).forEach(key => {
            register(`${item.ui}.${key}`);
        });
    }, [providentFundDetails, setValue]);

    useEffect(() => {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
                setState(null);
            }, 10000);
            return () => {
                clearTimeout(timer)
            };
        }
    }, [state]);
    //#endregion

    //#region Submit
    const onSubmit = data => {
        let startDateBeforeEndDate = false;
        let remainingObjects = [];
        Object.keys(data).forEach((key, index) => {
            if (!insertData.includes(key) && !deletedItems.includes(key)) {
                remainingObjects.push(data[key]);
            }

            if (!isStartDateBeforeEndDate(data[key]?.startdate, data[key]?.enddate)) {
                startDateBeforeEndDate = true;
                return;
            }
        });
        if (startDateBeforeEndDate) {
            setState('endDateBeforeStartDate');
            return;
        }
        insertData.forEach((ui, indexInsert) => {
            deletedItems.forEach((delUi, indexDelete) => {
                if (ui === delUi) {
                    insertData.splice(indexInsert, 1);
                    deletedItems.splice(indexDelete, 1);
                }
            });
        });
        const insertObjects = findObjects(data, insertData);
        return submitData(insertObjects, remainingObjects, deletedItems)
    };

    const submitData = async (insertData, updateData, deleteData) => {
        let newPromises = [];
        let deleteSucc = true;
        let updateSucc = true;
        let insertSucc = true;
        let employeeid = selectedEmployee?.employeeID;
        setState('saving');
        if (insertData.length > 0)
            newPromises.push(
                insertProvidentFund(insertData, employeeid).then((res) => {
                    if (res?.status === 200) insertSucc = true;
                }).catch(() => { })
            )
        if (deleteData.length > 0)
            newPromises.push(
                deleteProvidentFund(deleteData, employeeid).then((res) => {
                    if (res?.status === 200) deleteSucc = true;
                }).catch(() => { })
            )
        if (updateData.length > 0)
            newPromises.push(
                updateProvidentFund(updateData, employeeid).then((res) => {
                    if (res?.status === 200)
                        updateSucc = true;
                }).catch(() => { })
            )
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        setState('deleteFailed');
                    }
                    else
                        setState('issueMessage');
                }
                else if (deleteSucc && updateSucc && insertSucc) {
                    setState('allOperationsSuccMess');
                }
            });
        } catch (error) {
            console.log(error)
        }
    }
    //#endregion

    //#region Helpers
    const findObjects = (mainObject, arr) => {
        return arr.map(ui => {
            const innerObject = mainObject[ui];
            if (innerObject) {
                return {
                    ...innerObject, ui,
                    employeeID: selectedEmployee?.employeeID,
                    company: selectedCompany?.code,
                };
            }
            return null;
        }).filter(item => item !== null);
    };

    const isStartDateBeforeEndDate = (startDate, endDate) => {
        if (!startDate || !endDate) return true;

        const parsedDateStartDate = parseDate(startDate);
        const parsedDateEndDate = parseDate(endDate);

        if (parsedDateStartDate <= parsedDateEndDate) {
            return true;
        }
        return false;
    }

    function parseDate(dateString) {
        const [day, month, year] = dateString.split('-');
        return new Date(year, month - 1, day); // month is 0-indexed in JavaScript Date
    }
    //#endregion

    //#region Handlers
    const handleAddPress = () => {
        let exceptions = [];
        rowAdd(providentFundDetails, setProvidentFundDetails, exceptions, [], ref, t, [], [], changes, setChanges, insertData, setInsertData, id = 'ui');
    };

    const handleRemovePress = () => {
        handleCancelChanges(setProvidentFundDetails, originalProvidentFundDetails, setDeletedItems, setChanges, setDuplicates);
    };

    const handleDelete = (item, index, attribute, modal) => {
        rowDelete(item, index, attribute, changes, setChanges, providentFundDetails, setProvidentFundDetails, setDeletedItems, ref);
        unregister(`items.${item.ui}`);
    }
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion

    //#region Render
    const renderItem = useCallback(({ item, index }) => {
        return (
            <Card
                style={[styles.cardStyleLocation]} >
                <Card.Content>
                    <FlatListView
                        styles={styles}
                        control={control}
                        item={item}
                        index={index}
                        convertDate={convertDate}
                        handleDelete={handleDelete}
                        modal={modal}
                        setValue={setValue}
                        providentFundDropdown={providentFundDropdown}
                        contrEmplDropdown={contrEmplDropdown}
                        contrEmployerDropdown={contrEmployerDropdown}
                        width={width}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }, [providentFundDetails]);
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion


    return (
        <>
            <View style={styles.iconRow}>
                <View style={styles.leftIcons}>
                    <Ionicons
                        name={"add-circle-outline"}
                        style={styles.icon}
                        onPress={handleAddPress}
                    />
                    <Ionicons
                        name={"remove-circle-outline"}
                        style={styles.icon}
                        onPress={handleRemovePress}
                    />
                </View>
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {state && showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type='EDIT_EMPLOYEE_STATE'
                    />}
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <FlatList
                style={{ height: height / 3, flexGrow: 0 }}
                data={providentFundDetails}
                keyExtractor={(item, index) => `${item?.ui}`}
                renderItem={renderItem}
                scrollEnabled={true}
                refreshing={isLoading}
                ref={ref}
                initialNumToRender={10}
                ListHeaderComponent={
                    <CustomLabel
                        value={`${selectedEmployee?.name}'s ${t(`common:provFundTitle`)}`}
                        type='SUBTITLE'
                    />
                }
                ListEmptyComponent={
                    isLoading ? (
                        <ActivityIndicator animating={true} color={colors.blue} />
                    ) : (
                        <CustomLabel
                            value={t("common:provFundLoadingPreview")}
                            type="NO_BRANCHES"
                        />
                    )
                }
            />
            <View style={[styles.functionalityButtons]}>
                <CustomButton
                    text={t('common:saveChanges')}
                    onPress={handleSubmit(onSubmit)}
                    type='BUTTON_SAVE'
                    textTop='0'
                    sz={15}
                />
            </View>
        </>
    );
};

export default HRAdminProvidentFund;